export default "__VITE_PUBLIC_ASSET__9d8d2715__"